//region block: pre-declaration
//endregion
function get_undefined() {
  return undefined_0;
}
var undefined_0;
//region block: init
undefined_0 = null;
//endregion
//region block: exports
export {
  get_undefined as get_undefined2wip5bguf98cp,
};
//endregion
